// src/features/intervene/state/interveneAtoms.js
import { atom } from 'recoil';
import { INTERVENE_LIST_PAGE_SIZE, INTERVENE_USER_TABS } from '../constants/interveneApi';
import { DEFAULT_CONTEXT_DRAWER_TAB } from '../constants/contextDrawerTabs';

const readSessionValue = (key, fallback) => {
  if (typeof window === 'undefined') return fallback;

  try {
    const rawValue = window.sessionStorage.getItem(key);
    return rawValue ? JSON.parse(rawValue) : fallback;
  } catch (error) {
    return fallback;
  }
};

const persistSessionAtom = (key, fallback) => ({ setSelf, onSet }) => {
  const storedValue = readSessionValue(key, fallback);
  if (storedValue !== undefined) {
    setSelf(storedValue);
  }

  onSet((newValue, _, isReset) => {
    if (typeof window === 'undefined') return;

    if (isReset) {
      window.sessionStorage.removeItem(key);
      return;
    }

    if (newValue === undefined || newValue === null) {
      window.sessionStorage.removeItem(key);
      return;
    }

    if (typeof newValue === 'object' && Object.keys(newValue).length === 0) {
      window.sessionStorage.removeItem(key);
      return;
    }

    window.sessionStorage.setItem(key, JSON.stringify(newValue));
  });
};

export const interveneUserListAtom = atom({
  key: 'interveneUserListAtom_v2',
  default: { users: [], total_count: 0, has_next: false },
});

export const interveneUserDetailAtom = atom({
  key: 'interveneUserDetailAtom_v2',
  default: {},
  effects_UNSTABLE: [persistSessionAtom('interveneUserDetailAtom_v2', {})],
});

export const interveneMessageListAtom = atom({
  key: 'interveneMessageListAtom_v2',
  default: {
    messages: [],
    total_count: 0,
    filters: {
      page: 1,
      phone_number: '',
      botNumber: '',
    },
  },
});

export const interveneChatCountsAtom = atom({
  key: 'interveneChatCountsAtom_v2',
  default: { intervene: 0, min_15: 0, hrs_24: 0, history: 0, total: 0 },
});

export const interveneFilterAtom = atom({
  key: 'interveneFilterAtom_v2',
  default: {
    userType: INTERVENE_USER_TABS.RECENT_15M,
    botNumber: '',
    channelObj: null,
    organisationObj: null,
    organisationId: '',
    search: '',
    page: 1,
    pageLimit: INTERVENE_LIST_PAGE_SIZE,
  },
  effects_UNSTABLE: [persistSessionAtom('interveneFilterAtom_v2', {
    userType: INTERVENE_USER_TABS.RECENT_15M,
    botNumber: '',
    channelObj: null,
    organisationObj: null,
    organisationId: '',
    search: '',
    page: 1,
    pageLimit: INTERVENE_LIST_PAGE_SIZE,
  })],
});

export const interveneChannelListAtom = atom({
  key: 'interveneChannelListAtom_v2',
  default: [],
});

export const interveneUserJourneyAtom = atom({
  key: 'interveneUserJourneyAtom_v2',
  default: [],
});

export const interveneProfileLoadingAtom = atom({
  key: 'interveneProfileLoadingAtom_v2',
  default: false,
});

export const interveneLeadCampaignAtom = atom({
  key: 'interveneLeadCampaignAtom_v2',
  default: { campaign: null, webForm: null },
});

export const interveneAiSummaryAtom = atom({
  key: 'interveneAiSummaryAtom_v2',
  default: null,
});

export const interveneContextDrawerAtom = atom({
  key: 'interveneContextDrawerAtom_v2',
  default: {
    isOpen: false,
    activeTab: DEFAULT_CONTEXT_DRAWER_TAB,
  },
});

